import styled from 'styled-components';
import { Button, Form, Checkbox, Radio, Layout, Typography, Dropdown } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { MoreOutlined } from '@ant-design/icons';

const { Title } = Typography;

interface ColumnItemProps {
  rows: number;
}

export const RuleHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
  margin-right: 10px;
`;

export const OutlineBlueButton = styled(Button)`
  background-color: #fff;
  color: #0046ff;
  border-color: #0046ff;
`;

export const DetailDiv = styled.div`
  margin-bottom: 24px;
  font-weight: 600;
`;

export const FormItem = styled(Form.Item)`
  width: 100%;

  .ant-form-item-label > label {
    display: inline-flex;
    align-items: center;
    column-gap: 2px;
    font-weight: 600;
  }

  /* make the asterisk closer */
  .ant-form-item-label > label::after {
    margin-left: -12px !important;
  }
`;

export const FormInputItem = styled(Form.Item)`
  width: 50%;

  .ant-form-item-label > label {
    display: inline-flex;
    align-items: center;
    column-gap: 2px;
    font-weight: 600;
  }

  /* make the asterisk closer */
  .ant-form-item-label > label::after {
    margin-left: -12px !important;
  }
`;

export const MetricItem = styled(Checkbox.Group)`
  display: flex;
  flex-direction: column;
`;

export const ColumnItem = styled(Checkbox.Group)<ColumnItemProps>`
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: ${({ rows }) => `repeat(${rows}, auto)`};
  column-gap: 16px;
  margin-left: 20px;
`;

export const CheckboxSelectAll = styled(Checkbox)`
  margin-bottom: 8px;
`;

export const RadioGroupColumn = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 20px;
  margin-top: 5px;
`;

export const RadioSeverity = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 5px;
`;

export const FormItemAlign = styled(Form.Item)`
  text-align: right;
`;

export const FormItemCancel = styled(Button)`
  margin-right: 8px;
`;

export const FormLayout = styled(Layout)`
  background: #fff;
  min-height: 100vh;
`;

export const ContentLayout = styled(Content)`
  background: #fff;
  padding: 24px;
`;

export const DivLayout = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const DetailContentDiv = styled.div`
  margin: 0 24px;
`;

export const TitleLayout = styled(Title)`
  margin-left: 16px;
`;

export const StyledDropdown = styled(Dropdown)`
  .ant-dropdown-menu {
    text-align: left;
  }
`;

export const ActionButton = styled(Button).attrs({
  type: 'text',
  className: 'action-btn',
})`
  display: center;
  align-items: center;
  justify-content: left;
  padding: 4px;

  /* optional: tweak hover/focus */
  &:hover {
    background-color: #f5f5f5;
  }
`;

export const MoreIcon = styled(MoreOutlined)`
  font-size: 20px;
`;

export const CustomDisabledCheckbox = styled(Checkbox)`
  &.ant-checkbox-wrapper-disabled {
    span {
      color: rgb(0 0 0 / 85%); /* modern CSS notation */
    }
  }
`;
